module.exports = __webpack_public_path__ + "img/nav-design-hammered@2x.e1cf9ce.jpg";